import React, { Component } from 'react'
import ReactPlayer from 'react-player'

export class about extends Component {
  render() {
    return (
        <div id="about">
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <div className="row">                
                <ReactPlayer url='https://www.youtube.com/watch?v=UDKemWLh9Go' />
                
          </div>
        </div>
      </div>
    )
  }
}

export default about
